module.exports = __webpack_public_path__ + "static/step_2_3-ea2a429a6ce3c70d8862dbb7aaab5c4c.svg";